// frontend/src/utils/auth.js
// Check if token is valid
export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000;
    return Date.now() < expirationTime;
  } catch (error) {
    console.error('Error checking token validity:', error);
    return false;
  }
};

// Logout if token expired
export const logoutIfExpired = (user, setUser) => {
  if (user && !isTokenValid(user.token)) {
    console.log('Token expired, logging out');
    localStorage.removeItem('accessai-user');
    if (setUser) {
      setUser(null);
    }
    return true;
  }
  return false;
};

// Get user from localStorage
export const getCurrentUser = () => {
  try {
    const userData = localStorage.getItem('accessai-user');
    if (!userData) return null;

    const user = JSON.parse(userData);
    if (!isTokenValid(user.token)) {
      localStorage.removeItem('accessai-user');
      return null;
    }

    return user;
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};